import React from 'react';
import { Link } from 'react-router-dom';
import usePageTitle from '../usePageTitle';
import './ServicePage.css';

const Pentesting = () => {
  usePageTitle('Penetration Testing');

  return (
    <div className="service-page">
      <section className="service-hero pentest-hero">
        <div className="container">
          <div className="service-hero-content">
            <span className="service-hero-eyebrow">Service / Offensive Security</span>
            <h1 className="service-hero-title">Penetration Testing</h1>
            <p className="service-hero-subtitle">
              We find the holes before attackers do, then hand you the fixes. Network, web,
              cloud, and red-team engagements run by certified operators.
            </p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="service-content-grid">
            <div className="service-main-content">
              <h2>Secure Your Digital Assets</h2>
              <p>
                Our penetration testing identifies vulnerabilities before malicious actors can
                exploit them. We use industry-standard methodologies and current tooling for
                full, systematic coverage.
              </p>

              <h3>Our Testing Services</h3>
              <ul className="service-features-list">
                <li>Network infrastructure penetration testing</li>
                <li>Web application security assessments</li>
                <li>Red Team APT Threat Emulation</li>
                <li>Mobile application security testing</li>
                <li>Social engineering simulations</li>
                <li>Wireless network security testing</li>
                <li>Cloud security assessments</li>
                <li>Compliance testing (PCI DSS, HIPAA, SOX)</li>
                <li>Detailed remediation reports and guidance</li>
              </ul>

              <h3>Our Methodology</h3>
              <p>
                We follow established frameworks including OWASP, NIST, and PTES for thorough,
                systematic testing: reconnaissance, vulnerability assessment, exploitation, and
                detailed reporting.
              </p>
            </div>

            <div className="service-sidebar">
              <div className="service-card">
                <h3>Key Benefits</h3>
                <ul>
                  <li>Identify security gaps</li>
                  <li>Prevent data breaches</li>
                  <li>Ensure compliance</li>
                  <li>Improve security posture</li>
                  <li>Risk mitigation</li>
                </ul>
              </div>

              <div className="service-card">
                <h3>Industries Served</h3>
                <ul>
                  <li>Financial services</li>
                  <li>Healthcare</li>
                  <li>E-commerce</li>
                  <li>Government</li>
                  <li>Technology companies</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="service-cta-section">
            <h2>Secure Your Organization Today</h2>
            <p>Don't wait for a security incident. Let us help you identify and fix vulnerabilities now.</p>
            <Link to="/contact" className="btn btn-primary">
              Request Security Assessment
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pentesting;

